export const animationsStyles = {
    "@keyframes fade-in": {
        "0%": {
            opacity: "0",
        },
        "100%": {
            opacity: "1",
        },
    },
};